import { apiClient } from '@/api/client'
import type { CodigoQR, CodigoQRIn, CodigoQRUpdate, CodigosQRPaginados } from '../types'

const BASE = '/codigos-qr'

export async function getCodigosQR(params?: {
  page?: number
  page_size?: number
  search?: string
}): Promise<CodigosQRPaginados> {
  const { data } = await apiClient.get<CodigosQRPaginados>(`${BASE}/`, { params })
  return data
}

export async function createCodigoQR(payload: CodigoQRIn): Promise<CodigoQR> {
  const { data } = await apiClient.post<CodigoQR>(`${BASE}/`, payload)
  return data
}

export async function updateCodigoQR(id: number, payload: CodigoQRUpdate): Promise<CodigoQR> {
  const { data } = await apiClient.put<CodigoQR>(`${BASE}/${id}/`, payload)
  return data
}

export async function deleteCodigoQR(id: number): Promise<void> {
  await apiClient.delete(`${BASE}/${id}/`)
}

export async function previewQR(url: string): Promise<string> {
  const { data } = await apiClient.get<{ qr_base64: string }>(`${BASE}/preview/`, { params: { url } })
  return data.qr_base64
}
